/**
 * Esqueleto da tela de Comissoes com a mesma altura e a mesma grade dos
 * blocos finais: o painel atualiza sozinho e um salto de layout a cada carga
 * e desorientador.
 */

import { KpiCardSkeleton } from '../../../components/KpiCard';

const BLOCO = 'animate-pulse rounded-2xl border border-line bg-surface';

export function EsqueletoComissoes(): JSX.Element {
  return (
    <>
      <p role="status" className="sr-only">
        Carregando as comissões
      </p>
      <div aria-hidden="true" className="flex flex-col gap-6">
        <KpiCardSkeleton emphasis />
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <KpiCardSkeleton key={i} />
          ))}
        </div>
        <div className="grid gap-6 lg:grid-cols-2">
          <div className={`h-[26rem] ${BLOCO}`} />
          <div className={`h-[26rem] ${BLOCO}`} />
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <div className={`h-80 lg:col-span-2 ${BLOCO}`} />
          <div className={`h-80 ${BLOCO}`} />
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <div className={`h-80 lg:col-span-2 ${BLOCO}`} />
          <div className={`h-80 ${BLOCO}`} />
        </div>
        <div className={`h-[32rem] ${BLOCO}`} />
        <div className={`h-72 ${BLOCO}`} />
        <div className={`h-64 ${BLOCO}`} />
      </div>
    </>
  );
}
